//@ts-ignore
// @ts-nocheck
import { applySnapshot, getSnapshot, types } from "mobx-state-tree";
import {
  ACCEPT_ACTION,
  BOOK_LESSONS_ACTION,
  CONTACT_CLIENT_ACTION,
  DECLINE_ACTION,
  SUBMIT_FEEDBACK_ACTION,
} from "./utils/request";
import BookingStageStore, {
  BookingDurationStore,
  FeedbackStore,
} from "./bookingStage";

export const ActiveBooking = types.model("ActiveBooking", {
  startDate: types.string,
  endDate: types.string,
  schedule: types.array(types.string),
});

export const TutorEducation = types.model("TutorEducation", {
  school: types.maybeNull(types.string),
  country: types.maybeNull(types.string),
  course: types.maybeNull(types.string),
  grade: types.maybeNull(types.string),
  degree: types.maybeNull(types.string),
  startYear: types.maybeNull(types.string),
  endYear: types.maybeNull(types.string),
  isVerified: types.optional(types.boolean, false),
});

export const TutorWorkHistory = types.model("TutorWorkHistory", {
  company: types.string,
  role: types.string,
  startYear: types.optional(types.string, ""),
  endYear: types.optional(types.string, ""),
  isCurrent: types.optional(types.boolean, false),
  isTeachingRole: types.optional(types.boolean, false),
  showOnProfile: types.optional(types.boolean, false),
  isVerified: types.optional(types.boolean, false),
});

const SkillWithStatus = types.model("SkillWithStatus", {
  name: types.string,
  status: types.string,
});

export const TutorSubject = types
  .model("TutorSubject", {
    hourlyRate: types.optional(types.number, 0),
    hourlyDiscount: types.optional(types.number, 0),
    discountForExtraStudents: types.optional(types.number, 0),
    name: types.optional(types.string, ""),
    shortName: types.optional(types.string, ""),
    profileUrl: types.maybeNull(types.string),
    isCertified: types.optional(types.boolean, false),
    headline: types.optional(
      types.union(
        types.string,
        types.maybeNull(types.string),
        types.maybe(types.string)
      ),
      ""
    ),
    description: types.optional(
      types.union(
        types.string,
        types.maybeNull(types.string),
        types.maybe(types.string)
      ),
      ""
    ),
    related: types.optional(types.array(types.string), []),
    tuteriaName: types.maybeNull(types.string),
    skills_with_status: types.optional(types.array(SkillWithStatus), []),
  })
  .views((self) => {
    return {
      get shortSummary() {
        return {
          name: self.tuteriaName,
          hourlyRate: self.hourlyRate,
          hourlyDiscount: self.hourlyDiscount,
          discountForExtraStudents: self.discountForExtraStudents,
        };
      },
    };
  });

export const TutorCertification = types.model("TutorCertification", {
  award: types.optional(types.string, ""),
  institution: types.optional(types.string, ""),
});

const TestimonialResponse = types.model("TestimonialResponse", {
  comment: types.optional(types.string, ""),
  date: types.optional(types.string, ""),
});

export const TestimonialStore = types.model("TestimonialStore", {
  title: types.optional(types.string, ""),
  photo: types.maybeNull(types.string),
  firstName: types.optional(types.string, ""),
  lastName: types.optional(types.string, ""),
  subjectsBooked: types.array(types.string),
  review: types.string,
  dateReviewed: types.string,
  lessonBooked: types.optional(types.number, 0),
  rating: types.optional(types.number, 0),
  response: types.maybeNull(TestimonialResponse),
});

export const TutorSummaryInfo = types.model("TutorSummaryInfo", {
  title: types.string,
  icon: types.string,
  description: types.string,
});

export const TutorResponseStore = types
  .model("TutorResponse", {
    id: types.union(
      types.optional(types.string, ""),
      types.maybe(types.number)
    ),
    status: types.optional(types.string, ""),
    reason: types.optional(types.string, ""),
    comment: types.optional(types.string, ""),
    dateSubmitted: types.optional(types.string, ""),
    bookingStage: types.optional(BookingStageStore, {}),
    callFeedback: types.optional(FeedbackStore, {}),
    responseTime: types.union(
      types.optional(types.number, 0),
      types.optional(types.string, "")
    ),
    bookingDuration: types.optional(BookingDurationStore, {}),
    tutor_slug: types.optional(types.string, ""),
  })
  .views((self) => {
    return {
      get submittedDate() {
        return self.dateSubmitted || self.bookingStage.dateSubmitted;
      },
      get bookingStageSummary() {
        return {
          current: self.bookingStage.current,
          timeUpdated: self.bookingStage.summary,
        };
      },
      get fullData() {
        return {
          ...getSnapshot(self),
          bookingStage: self.bookingStage.summary,
        };
      },
    };
  })
  .actions((self) => {
    const updateBookingStage = (text, dateSubmitted, revert) => {
      if ([ACCEPT_ACTION, DECLINE_ACTION].includes(text)) {
        // tutor declines or accepts the job
        return self.bookingStage.providedResponseToRequest(
          dateSubmitted,
          revert
        );
      } else if ([CONTACT_CLIENT_ACTION].includes(text)) {
        return self.bookingStage.receivedClientContacts(dateSubmitted, revert);
      } else if (text == SUBMIT_FEEDBACK_ACTION) {
        return self.bookingStage.contactedClient(dateSubmitted, revert);
      } else if (text == BOOK_LESSONS_ACTION) {
        return self.bookingStage.providedFeedbackOnMeetingWithClient(
          dateSubmitted,
          revert
        );
      }
    };
    return {
      updateBookingStage,
      updateSelf(data) {
        applySnapshot(self, { ...getSnapshot(self), ...data });
      },
    };
  });
